module.exports = __webpack_public_path__ + "img/arrow-up.da7bdd07.svg";